export const parseBooleanEnvFlag = (
  value?: string | null,
  isSuperAdmin: boolean = false
): boolean => {
  if (isSuperAdmin) return true;
  if (!value) return false;
  return ["true", "1", "yes"].includes(value.toLowerCase());
};
